import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './shared/guard/auth.guard';
import { hrGuard } from './shared/guard/hr.guard';
import { hrReportGuard } from './shared/guard/hr-report.guard';
import { RedirectHandlerComponent } from './redirect-handler/redirect-handler.component';
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { GlobalAssessmentComponent } from './public/global-assessment/global-assessment.component';

const routes: Routes = [
  {
    path: 'redirect',
    component: RedirectHandlerComponent, 
  },
  {
    path: 'verification', component: UserVerificationComponent,
  },
  {
    path: 'assessment/public',
    component: GlobalAssessmentComponent,
    canActivate: [hrReportGuard],
  },
  {
    path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'main', loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate:[authGuard]
  },
  {
    path: 'examination', loadChildren: () => import('./examination/examination.module').then(m => m.ExaminationModule),
    canActivate:[authGuard]
  },
  {
    path:'mobile-verification', loadChildren: () => import('./mobile-verification/mobile-verification.module').then(m => m.MobileVerificationModule),
    // canActivate:[authGuard]
  },

  {
    path: 'super-admin', loadChildren: () => import('./super-admin/super-admin.module').then(m => m.SuperAdminModule),
    // canActivate:[adminGuard]
  },

  {
    path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    // canActivate:[adminGuard]
  },
  {
    path: 'hr', loadChildren: () => import('./hr/hr.module').then(m => m.HrModule),
    canActivate:[hrGuard]
  },
  // PUBLIC CANDIDATE REPORT PAGE (/public/candidate-view?tokenId=...) - commented out for now.
  // Opened the shareable link produced by "Generate Public Link" on hr/view-candidate
  // (bot drives): verified the token, asked for a password, then showed the candidate
  // report without login. Feature disabled; to restore, uncomment this route together
  // with the Generate Public Link blocks in view-candidate and the password check in
  // public-candidate-report.
  // {
  //   path: 'public',
  //   loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  //   // NO canActivate guard - completely public
  // },
  {
    path: 'college-admin', loadChildren: () => import('./college-admin/college-admin.module').then(m => m.CollegeAdminModule),
    // canActivate:[collegeAdminGuard]
  },
  // {
  //   path:"full-screen",component:FullscreenComponent
  // },
  // {
  //   path:"microphone-test",component:MicrophoneTestComponent
  // },
  // {
  //   path:"screen-recorder",component:ScreenRecorderComponent
  // },
  // {
  //   path:"web-cam",component:WebCamComponent
  // }
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
